// For public routes like /login, /home
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const RegistrationAwarePublicRoute = ({ component: Component, ...rest }) => {
  const { isInRegistration, steps, currentStepIndex } = useSelector(
    (state) => state.registration
  );

  return (
    <Route
      {...rest}
      render={(props) =>
        isInRegistration ? (
          <Redirect to={steps[currentStepIndex]} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default RegistrationAwarePublicRoute;
